export default __webpack_public_path__ + "static/media/instagram.7752f13f.svg";